<template>
  <div v-if="(!loaded)" class="loading-spinner"></div>
  <div v-if="(loaded)" >
    <div class="conteudoGeral-view">
      <div class="auto-container">
        <div class="title-group">
          <span class="sectionTitle">
            <span v-if="(tipoConteudo != '')" class="redirectConteudoGeral" @click="fc_goRoute(tipoConteudo)"> {{ fc_getText(null,tipoConteudo) }} </span>
            <span v-if="(tipoConteudo != '')"> {{ ' << ' }} </span>
            <span> {{ fc_removeHTML(item.titulo) }} </span>
          </span>
          <div class="subtitulo" v-html="item.titulo"></div>
        </div>
        <div class="conteudoGeralText" v-html="item.conteudo"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      loaded: false,
      item: {},
      temaId: null,
      tipoConteudo: '',
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {
    mt_start() {
      this.temaId = this.$route.params.id;
      if (this.temaId == null) { this.mt_goBack(); }
      else {
        if (this.$route.path != '') {
          let segmentos = this.$route.path.split('/');
          let tipo = segmentos[segmentos.length - 2];
          if (tipo != null && tipo != '') {
            this.tipoConteudo = tipo;
          }
        }
        this.mt_loadData();
      }
    },
    mt_loadData() {
      this.loaded = false;
      this.fc_fetch({ endpoint: 'ConteudoGeralTema/' + this.temaId + '/', method: 'GET', success: this.mt_loadData_success, error: () => { this.mt_goBack(); } });
    },
    mt_loadData_success(response) {
      if (response != null && response.item != null && response.item.visualizacao == 1) {
        this.item = response.item;
        this.loaded = true;
      } else {
        this.mt_goBack();
      }
    },
    mt_goBack() {
      this.fc_goRoute('home');
    },
  },
  created() {},
  mounted() {
    this.mt_start();
  },
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.conteudoGeral-view {
  padding-top: 150px;
}
.conteudoGeralText {
  margin-bottom: 65px;
}
.title-group {
  margin-bottom: 35px;
}
.redirectConteudoGeral {
  cursor: pointer;
}
.redirectConteudoGeral:hover {
  color: var(--ibase-color);
}
</style>
